
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.SummaryViewAllAccountGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class SummaryViewAllAccountGrid extends SiteEntityGrid<SummaryViewAccountRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.SummaryViewAllAccount'; }
        protected getDialogType() { return SummaryViewAllAccountDialog  ; }
        protected getIdProperty() { return SummaryViewAccountRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewAccountRow.localTextPrefix; }
        protected getService() { return SummaryViewAccountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._viewCode);
        }

        private _viewCode: string;

        public set viewCode(value: string) {
            if (this._viewCode !== value) {
                this._viewCode = value;
                this.setEquality(SummaryViewAccountRow.Fields.InstanceViewCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<SummaryViewAccountRow>{
                InstanceViewCode: this._viewCode
            });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._viewCode;
        }
    }
}